import { render, staticRenderFns } from "./task_customer.vue?vue&type=template&id=3ae174b4&scoped=true"
import script from "./task_customer.vue?vue&type=script&lang=js"
export * from "./task_customer.vue?vue&type=script&lang=js"
import style0 from "./task_customer.vue?vue&type=style&index=0&id=3ae174b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae174b4",
  null
  
)

export default component.exports